import React, {useState} from 'react'
import millify from 'millify'
import { useParams } from 'react-router-dom'
import HTMLReactParser from 'html-react-parser'
import {Row, Col, Typography, Select} from 'antd'
import { MoneyCollectOutlined, DollarCircleOutlined, FundOutlined, ExclamationCircleOutlined, StopOutlined, TrophyOutlined, CheckOutlined, NumberOutlined, ThunderboltOutlined } from '@ant-design/icons';
import { useGetCryptoDetailsQuery, useGetCryptoHistoryQuery } from '../services/cryptoApi'
import Loader from './Loader';
import LineChart from './LineChart'

const {Title, Text} = Typography;
const {Option} = Select;

const CryptoDetails = () => {
    const { coinId } = useParams();
    const [timePeriod, setTimePeriod] = useState('7d');
    const {data, isFetching} =useGetCryptoDetailsQuery(coinId);
    const {data:coinHistory} =useGetCryptoHistoryQuery({coinId, timePeriod})
    const cd = data?.data?.coin;
    console.log(data);
    if (isFetching) return <Loader />;
    
     const time = ['3h', '24h', '7d', '30d', '1y', '3m', '3y', '5y'];

  const stats = [
    { title: 'Price to USD', value: `$ ${cd.price && millify(cd.price)}`, icon: <DollarCircleOutlined /> },
    { title: 'Rank', value: cd.rank, icon: <NumberOutlined /> },
    { title: '24h Volume', value: `$ ${cd.volume && millify(cd.volume)}`, icon: <ThunderboltOutlined /> },
    { title: 'Market Cap', value: `$ ${cd.marketCap && millify(cd.marketCap)}`, icon: <DollarCircleOutlined /> },
    { title: 'All-time-high(daily avg.)', value: `$ ${millify(cd.allTimeHigh.price)}`, icon: <TrophyOutlined /> },
  ];

  const genericStats = [
    { title: 'Number Of Markets', value: cd.numberOfMarkets, icon: <FundOutlined /> },
    { title: 'Number Of Exchanges', value: cd.numberOfExchanges, icon: <MoneyCollectOutlined /> },
    { title: 'Aprroved Supply', value: cd.approvedSupply ? <CheckOutlined /> : <StopOutlined />, icon: <ExclamationCircleOutlined /> },
    { title: 'Total Supply', value: `$ ${millify(cd.totalSupply)}`, icon: <ExclamationCircleOutlined /> },
    { title: 'Circulating Supply', value: `$ ${millify(cd.circulatingSupply)}`, icon: <ExclamationCircleOutlined /> },
  ];
    return (
         <Col className="coin-detail-container">
            <Col className="coin-heading-container">
                <Title level={2} className="coin-name">
                {data?.data?.coin.name} ({data?.data?.coin.slug}) Price
                </Title>
                <p>{cd.name} live price in US Dollar (USD). View value statistics, market cap and supply.</p>
            </Col>
            <Select defaultValue="7d" className="select-timeperiod" placeholder="Select Timeperiod" onChange={(value) => setTimePeriod(value)}>
                {time.map((date) => <Option key={date}>{date}</Option>)}
            </Select>
             <LineChart coinHistory={coinHistory} currentPrice={millify(cd.price)} coinName={cd.name} />
            <Col className='stats-container'>
                <Col className='coin-value-statistics'>
                    <Col className='coin-value-statistics-heading'>
                        <Title level={3} className='coin-details-heading'>
                            {cd.name} Value Statistics
                        </Title>
                        <p> An overview of statistics of {cd.name}</p>
                    </Col>
                    {stats.map(({icon, title, value}) => (
                        <Col className='coin-stats'>
                            <Col className='coin-stats-name'>
                                <Text>{icon}</Text>
                                <Text>{title}</Text>
                            </Col>
                            <Text className='stats'>{value}</Text>
                        </Col>
                    ))}
                </Col>
                <Col className='other-stats-info'>
                    <Col className='coin-value-statistics-heading'>
                        <Title level={3} className='coin-details-heading'>
                            Other stats info
                        </Title>
                        <p> An overview of statistics of {cd.name}</p>
                    </Col>
                    {genericStats.map(({icon, title, value}) => (
                        <Col className='coin-stats'>
                            <Col className='coin-stats-name'>
                                <Text>{icon}</Text>
                                <Text>{title}</Text>
                            </Col>
                            <Text className='stats'>{value}</Text>
                        </Col>
                    ))}
                </Col>
            </Col>
            <Col className='coin-desc-link'>
                <Row className='coin-desc'>
                    <Title level={3} className='coin-details-heading'> What is {cd.name}?</Title>
                    {HTMLReactParser(cd.description)}
                </Row>
                <Col className='coin-links'>
                    <Title level={3} className='coin-details-heading'>{cd.name} Links</Title>
                    {cd.links?.map((link) =>(
                        <Row className='coin-link' key={link.name}>
                            <Title level={5} className='link-name'>{link.type}</Title>
                            <a href={link.url} target="_blank" rel="noreferrer">{link.name}</a>
                        </Row>
                    ))}
                </Col>
            </Col>
      </Col>
    );
}

export default CryptoDetails
